export const LANDING = '/';
export const PLANS = '/plans';
export const PASSWORD_FORGET = '/recovery';
export const ADMIN = '/admin';
export const TERMS_AND_CONDITIONS = '/termsAndConditions';
export const PRIVACY_POLICY = '/privacyPolicy';


//Vendor
export const VENDOR_LOGIN = '/vendorLogin';
export const VENDOR_REGISTRATION = '/vendorRegistration';
export const VENDOR_DASHBOARD = '/vendorDashboard';
export const VENDOR_ACCT_DETAILS = '/vendorAcctDetails';
export const VENDOR_EDIT_ACCT_DETAILS = '/vendorEditAcctDetails';
export const VENDOR_CONVERSATIONS = '/vendorConversations';
export const VENDOR_QUOTES = '/vendorQuotes';
export const VENDOR_INVOICES = '/vendorInvoices';
export const VENDOR_RECEIPTS = '/vendorReceipts';
export const VENDOR_MAPS = '/vendorMaps';
export const VENDOR_SERVICES = '/vendorServices';
export const VENDOR_CONTACT = '/vendorContact';
export const VENDOR_APPTS = '/vendorAppointments';
export const VENDOR_APPT = '/vendorAppointment/:custID';
export const VENDOR_EDIT_APPT = '/VendorEditAppt/:documentID';

export const VENDOR_CONVERSATION = '/vendorConversation/:productName/:custID';
export const CUSTOMER_MAP = '/customerMap/:fullAddress';


//Customer
export const LOGIN = '/login';
export const DASHBOARD = '/dashboard';
export const REGISTRATION = '/registration';
export const ACCT_DETAILS = '/acctDetails';
export const EDIT_ACCT_DETAILS = '/editAcctDetails';
export const BILLING = '/billing';
export const SERVICES = '/services';
export const SUBSCRIBE = '/subscribe';
export const NEEDED_SERVICE = '/neededService';
export const INVOICES = '/invoices';
export const RECEIPTS = '/receipts';
export const CALENDAR = '/calendar';
export const UNSUBSCRIBE = '/unsubscribe';
export const CONTACT = '/contact';
export const CONVERSATIONS = '/conversations';
export const CONVERSATION = '/conversation/:productName/:vendorID';
export const CART = '/cart';
export const PAYMENT = '/payment';
export const ORDER = '/order/:orderID';
export const CUSTOMERS_SERVICES_CHAT = '/customersServicesChat/:productName';
export const CUSTOMER_APPT = '/customeraPPT/:documentID';
export const FILING_CABINET = '/filingCabinet';
